import { cronosClient } from "@/config/client"

export function remove(milestoneId: string) {
  return cronosClient.del(`/v1/milestones/${milestoneId}`)
}
